module.exports = __webpack_public_path__ + "img/label-icon.83c204ab.png";